import {
    GET_UPFIT_OPTION,
    SET_UPFIT_OPTION
} from "./UpfitOptionType"

const getUpfitOption = (subTypeId: any) => ({
    type: GET_UPFIT_OPTION,
    subTypeId
});

const setUpfitOption = (upfitOptionList: any) => ({
    type: SET_UPFIT_OPTION,
    upfitOptionList: upfitOptionList
});

export {
    getUpfitOption,
    setUpfitOption
}
